// extracted by mini-css-extract-plugin
export default {"myModal":"CustomModal_myModal__FA3kK","myModalContent":"CustomModal_myModalContent__BqRyF","active":"CustomModal_active__UszEc"};